<template>
  <div class="container">
    <header class="header">
      <div class="logo">
        <a href="/" class="logo1"><img src="http://kj.entfly.com/template/yibai_guanwang/public/img/logo.png"
            alt="品牌控价-助力软件"></a>
        <a href="/" class="logo2"><img src="http://kj.entfly.com/template/yibai_guanwang/public/img/logo2.png"
            alt="品牌控价-助力软件"></a>
      </div>
      <div class="nav" :class="leftMenu ? 'rights' : 'right'">
        <a href="javascript:void(0)" class="btn_control" :class="leftMenu ? 'open' : 'close'" @click="leftMenuClick"></a>
        <nav class="list" v-if="!leftMenu">
          <u class="mask"></u>
          <ul>
            <li :data-index="index" v-for="(items, index) in leftMenuData" :key="index" :class="index == 0 ? 'on' : ''" @click="SwiperIndexClick(index)">
              <a :href="index == 9 ? 'http://www.powersoft.cc' : 'javascript:void(0)'" class="ch">{{
                items.name }}</a>
              <a :href="index == 9 ? 'http://www.powersoft.cc' : 'javascript:void(0)'">{{ items.name1 }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    <div class="contents swiper" ref="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide section home swiper-slide-visible" :class="currentIndex == '0' ? 'active' : ''">
          <div class="box ">
            <div class="home-left" ref="homeLeft">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="index in HomeNavData" :key="index">
                  <div :class="'slidepannel slidepannel-' + index"></div>
                </div>
              </div>
            </div>
            <div class="home-right" ref="homeRight">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="slidepannel slidepannel-1"></div>
                </div>
                <div class="swiper-slide">
                  <div class="slidepannel slidepannel-2"></div>
                </div>
                <div class="swiper-slide">
                  <div class="slidepannel slidepannel-3"></div>
                </div>
              </div>
              <!-- <div class="home-nav" v-html="homeLeftIndexData[homeLeftIndex]" @click="onHomeClick(homeLeftIndex)"></div> -->
              <div class="home-nav">
                <template v-if="homeLeftIndex == 0">
                  <i class="on"></i>
                  <i class="even" ></i>
                  <i ></i>
                </template>
                <template v-else-if="homeLeftIndex == 1">
                  <i ></i>
                  <i class="on even"></i>
                  <i ></i>
                </template>
                <template v-else>
                  <i ></i>
                  <i class="even"></i>
                  <i class="on" ></i>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide section service" :class="currentIndex == '1' ? 'active' : ''">
          <div class="box">
            <div class="caption">
              <h2 class="en"></h2>
              <h2 class="ch"></h2>
            </div>
            <div class="servitems">
              <!--[diy=yibaidiy01]-->
              <div id="yibaidiy01" class="area"></div><!--[/diy]-->
              <ul class="swiper-wrapper">
                <li class="swiper-slide">
                  <div class="item item1">
                    <span class="pic"></span>
                    <span class="intro">经销商以低于品牌厂家指导价进行网络销售</span>
                    <span class="name">解决低价乱价</span>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item item2">
                    <span class="pic"></span>
                    <span class="intro">定向监控疑似窜货、水货和假货商家</span>
                    <span class="name">解决窜货水货</span>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item item3">
                    <span class="pic"></span>
                    <span class="intro">假货仿冒产品品质无法得到保证</span>
                    <span class="name">解决假货仿货</span>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item item4">
                    <span class="pic"></span>
                    <span class="intro">非授权店铺倾销产品影响线上授权商家利益</span>
                    <span class="name">解决非授权销售</span>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item item5">
                    <span class="pic"></span>
                    <span class="intro">指未经过品牌商授权，私自盗用品牌商标等销售产品</span>
                    <span class="name">淘宝知识产权</span>
                  </div>
                </li>
              </ul>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
            <div class="advertising"></div>
            <a href="javascript:void(0);" class="tonext"></a> <u class="san"></u>
          </div>
        </div>
        <div class="swiper-slide section cases" :class="currentIndex == '2' ? 'active' : ''">
          <div class="box">
            <div class="caption">
              <h2 class="en"></h2>
              <h2 class="ch"></h2>
            </div>
            <div class="caseitems">
              <!--[diy=yibaidiy02]-->
              <div id="yibaidiy02" class="area"></div><!--[/diy]-->
              <ul class="swiper-wrapper">

                <li class="swiper-slide">
                  <div class="item">
                    <a href="portal.php?mod=view&amp;aid=6" class="pic">
                      <img src="http://kj.entfly.com/data/attachment/portal/201703/16/182220eg5k4thtvzsno5ct.png"
                        height="200px"></a>
                    <div class="info">
                      <a href="portal.php?mod=view&amp;aid=6" class="name">苏宁易购控价</a>
                      <span class="intro"></span>
                    </div>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item">
                    <a href="portal.php?mod=view&amp;aid=5" class="pic">
                      <img src="http://kj.entfly.com/data/attachment/portal/201703/16/182116c5k237sna3aws8s0.png"
                        height="200px"></a>
                    <div class="info">
                      <a href="portal.php?mod=view&amp;aid=5" class="name">1号店控价</a>
                      <span class="intro"></span>
                    </div>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item">
                    <a href="portal.php?mod=view&amp;aid=4" class="pic">
                      <img src="http://kj.entfly.com/data/attachment/portal/201703/16/182004i6mmk8ifcci812f8.png"
                        height="200px"></a>
                    <div class="info">
                      <a href="portal.php?mod=view&amp;aid=4" class="name">闲鱼控价</a>
                      <span class="intro"></span>
                    </div>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item">
                    <a href="portal.php?mod=view&amp;aid=3" class="pic">
                      <img src="http://kj.entfly.com/data/attachment/portal/201703/16/181439im3a3wz404d2e4jw.png"
                        height="200px"></a>
                    <div class="info">
                      <a href="portal.php?mod=view&amp;aid=3" class="name">京东控价</a>
                      <span class="intro"></span>
                    </div>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item">
                    <a href="portal.php?mod=view&amp;aid=2" class="pic">
                      <img src="http://kj.entfly.com/data/attachment/portal/201703/16/181615glid91bi15zogvi6.png"
                        height="200px"></a>
                    <div class="info">
                      <a href="portal.php?mod=view&amp;aid=2" class="name">天猫控价</a>
                      <span class="intro"></span>
                    </div>
                  </div>
                </li>
                <li class="swiper-slide">
                  <div class="item">
                    <a href="portal.php?mod=view&amp;aid=1" class="pic">
                      <img src="http://kj.entfly.com/data/attachment/portal/201703/16/181802u8i86oym8o8d31oo.png"
                        height="200px"></a>
                    <div class="info">
                      <a href="portal.php?mod=view&amp;aid=1" class="name">淘宝控价</a>
                      <span class="intro"></span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- <div class="scrollbar"> <u class="btn_scroll"></u>
              <div class="pagenum"></div>
              <a style="display:none;" class="more" href="/kongjia"></a>
            </div> -->
          </div>
        </div>
        <div class="swiper-slide section customer" :class="currentIndex == '3' ? 'active' : ''">
          <div class="box">
            <div class="customerwrap">
              <div class="cooperation">
                <div class="row1"></div>
                <div class="row2"></div>
                <div class="row3">426</div>
                <div class="row4"></div>
                <div class="row5"></div>
              </div>
              <div class="itemlist">
                <ul>
                  <li class="item1"></li>
                  <li class="item2"></li>
                  <li class="item3"></li>
                  <li class="item4"></li>
                  <li class="item5"></li>
                  <li class="item6"></li>
                  <li class="item7"></li>
                  <li class="item8"></li>
                  <li class="item9"></li>
                  <li class="item10"></li>
                  <li class="item11"></li>
                  <li class="item12"></li>
                  <li class="item13"></li>
                  <li class="item14"></li>
                  <li class="item15"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide section about" :class="currentIndex == '4' ? 'active' : ''">
          <div class="box">
            <div class="itemlist">
              <ul>
                <li class="letter letter-a">
                  <i class="title"></i>
                  <div class="info">
                    <h2>团队</h2>
                    <p>共同的归属感、认同感、使命感，产生强大的凝聚力<br /><br />
                      热情、专业、执着、正直、才华洋溢是助力软件的团队气质</p>
                  </div>
                </li>
                <li class="letter letter-b">
                  <i class="title"></i>
                  <div class="info">
                    <h2>品牌</h2>
                    <p>国家高新技术企业<br /><span style="font-size:48px; line-height:56px;">百余家</span><br />蒙牛 伊利 垦丰种业 闽榕茶叶 雅士利
                      完达山 珠峰冰川 君乐宝 亨氏 ......</p>
                  </div>
                </li>
                <li class="letter letter-o">
                  <i class="title"></i>
                  <div class="info">
                    <h2>责任</h2>
                    <p>我们办企业的目的是什么？<br />
                      是解决就业，是完成经济责任，是给员工实现价值的平台。<br />
                      都对，但是我们<br />
                      认为承担社会责任同样重要。<br />
                      会号召员工保护资源和环境。<br />
                      ......</p>
                  </div>
                </li>
                <li class="letter letter-u">
                  <i class="title"></i>
                  <i class="title2"></i>
                </li>
                <li class="letter letter-t">
                  <i class="title"></i>
                  <div class="info">
                    <h2>招聘</h2>
                    <p><span style="font-size:16px;">责任感</span>：你是否敢于承担责任？出现问题时，并竭尽全力去解决问题？
                      <span style="font-size:16px;">工作热情</span>：我们认为只有对工作投入的人，才是对自己负责、对家庭负责、对社会负责的人。
                      <span style="font-size:16px;">交流能力</span>：你是否能和客户交流好，并得到客户认可？
                    </p>
                  </div>
                </li>
                <li class="intro">
                  <h2 class="title">助力软件</h2>
                  <div class="content">
                    <p>
                      北京助力软件有限公司成立于 2011 年 3
                      月，专业从事品牌全网价格管控，知识产权维护，是全国唯一一家可实现全网产品价盘管控的公司,为企业提供整体电商品牌渠道管控规划和解决方案，与淘宝、阿里巴巴、京东等大型电子商务网站建立战略合作关系,协助企业进行长期的网络市场侵权监测及处理。
                    </p>
                    <p>
                      公司团队以专业化、职业化、年轻化为主要特点，业务服务人员 100 余人,是一支具有强烈进取心和创新精神以及高度责任感的专业团队，成功完成了多起优秀案例。
                    </p>
                  </div>
                  <div class="pic">
                    <img src="http://kj.entfly.com/template/yibai_guanwang/public/img/about.jpg" alt="">
                  </div>
                </li>
                <li class="letter letter-s">
                  <i class="title"></i>
                  <i class="title2"></i>
                </li>
                <li class="letter"></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="swiper-slide section security" :class="currentIndex == '5' ? 'active' : ''">
          <div class="box">
            <div class="caption">
              <h2 class="en"></h2>
              <h2 class="ch"></h2>
            </div>
            <div class="itemlist">
              <ul>
                <li>
                  <div class="item item1">
                    <i></i>
                    <h2>实时监控</h2>
                    <p>软件实时监控数据<br />精准抓取<br />让低价无处遁形</p>
                  </div>
                </li>
                <li>
                  <div class="item item2">
                    <i></i>
                    <h2>处理量大</h2>
                    <p>专业团队24h全网监控<br />专业审查人员+审查系统<br />每日5000+问题链接审查能力</p>
                  </div>
                </li>
                <li>
                  <div class="item item3">
                    <i></i>
                    <h2>处理速度快</h2>
                    <p>专业渠道快于常规流程<br />紧急链接当天迅速处理<br />效率远超其他常规投诉方式</p>
                  </div>
                </li>
                <li>
                  <div class="item item4">
                    <i></i>
                    <h2>处理力度强</h2>
                    <p>恶意商家7-10工作日封店<br />采取有力有效综合手段<br />
                      坚定维护企业权利与利益</p>
                  </div>
                </li>
                <li>
                  <div class="item item5">
                    <i></i>
                    <h2>一对一服务</h2>
                    <p>采用一对一服务<br />
                      从治理方案沟通到渠道管控、<br />服务实施都有专人对接</p>
                  </div>
                </li>
                <li>
                  <div class="item item6">
                    <i></i>
                    <h2>管控健康秩序</h2>
                    <p>正面引导与维权管控<br />
                      3个月内处理全网90%问题链接<br />
                      构建健康的全网秩序</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="swiper-slide section response" :class="currentIndex == '6' ? 'active' : ''">
          <div class="box">
            <div class="caption">
              <span class="bian"></span>
            </div>
            <div class="itemwrap">
              <a href="javascript:void(0);" class="next"></a>
              <div class="swiper-container">

                <ul class="swiper-wrapper f_name_ss">
                  <div class="bd">
                    <li class="swiper-slide">
                      <div class="item" data-caseid="148">
                        <a href="portal.php?mod=view&amp;aid=9" class="pic">
                          <img src="http://kj.entfly.com/data/attachment/portal/201703/16/190834elqngnpxjr219wb2.jpg"
                            height="200px"></a>
                        <dl class="intro">
                          <dt>阿里利用大数据系统助力警方破获百 ...</dt>
                          <dd>阿里助力警方破获百万假冒卸妆水案 近日，深圳 ...</dd>

                        </dl>
                      </div>

                    </li>
                    <li class="swiper-slide">
                      <div class="item" data-caseid="148">
                        <a href="portal.php?mod=view&amp;aid=15" class="pic">
                          <img src="http://kj.entfly.com/data/attachment/portal/201703/16/193122cyj2roowuppb3rbo.jpg"
                            height="200px"></a>
                        <dl class="intro">
                          <dt>知识产权诉讼十大案例</dt>
                          <dd>案例一：“耶莉娅”商标侵权及不正当竞争案　　原 ...</dd>

                        </dl>
                      </div>

                    </li>
                    <li class="swiper-slide">
                      <div class="item" data-caseid="148">
                        <a href="portal.php?mod=view&amp;aid=7" class="pic">
                          <img src="http://kj.entfly.com/data/attachment/portal/201703/16/184744xkk58qye25o8x58q.jpg"
                            height="200px"></a>
                        <dl class="intro">
                          <dt>淘宝开始严查代运营服务市场 发现 ...</dt>
                          <dd>做网店没经验，销量上不去？我们为您提供网店代运 ...</dd>

                        </dl>
                      </div>

                    </li>
                    <li class="swiper-slide">
                      <div class="item" data-caseid="148">
                        <a href="portal.php?mod=view&amp;aid=8" class="pic">
                          <img src="http://kj.entfly.com/data/attachment/portal/201703/16/185424eqjj2tj2xxv8va1f.jpg"
                            height="200px"></a>
                        <dl class="intro">
                          <dt>本周最新天猫规则变动，你知道不？</dt>
                          <dd>淘宝天猫规则变动天天有，但本周最新变动你可知？ ...</dd>

                        </dl>
                      </div>

                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide section news" :class="currentIndex == '7' ? 'active' : ''">
          <div class="box">
            <div class="n-side">
              <div class="caption"></div>
              <div class="newslist">
                <div class="hd">
                  <img src="http://kj.entfly.com/template/yibai_guanwang/public/img/newslist.png" alt="">
                </div>
                <div class="bd">

                  <ul>
                    <li><A href="portal.php?mod=view&amp;aid=14">2016年8月 雅士利集团、三元乳业、亨氏奶粉先后成为我司服务客户</A></li>

                    <li><A href="portal.php?mod=view&amp;aid=13">2015年6月 君乐宝乳业成为我司长期战略合作伙伴</A></li>

                    <li><A href="portal.php?mod=view&amp;aid=12">2014年8月 完达山乳业就品牌控价成为我司长期战略合作伙伴</A></li>

                    <li><A href="portal.php?mod=view&amp;aid=11">2013年5月 闽榕茶业（福建）成为我司长期战略合作伙伴</A></li>

                    <li><A href="portal.php?mod=view&amp;aid=10">2012年7月 蒙牛乳业（集团）与助力软件达成长期战略合作协议</A></li>
                  </ul>
                </div>
                <div class="ft">
                  <a href="javascript:void(0)" class="prev">&lt;</a>
                  <a href="javascript:void(0)" class="next">&gt;</a>
                </div>
              </div>
            </div>
            <div class="n-main">
              <!-- start					 -->
              <div class="newsdetail">
                <img src="http://kj.entfly.com/template/yibai_guanwang/style/newpic.png" />
              </div>
              <!-- end -->

            </div>
          </div>
        </div>
        <div class="swiper-slide section contact" :class="currentIndex == '8' ? 'active' : ''">
          <div class="box">
            <div class="banner">
              <div class="banner1"></div>
            </div>
            <div class="itemlist">
              <div class="item">
                <div class="itembox">
                  <h2 class="title">助力软件</h2>
                  <p class="intro">
                    地址：北京市海淀区丰智东路13号朗丽兹写字楼9层
                    <br />
                    电话: 010-60608145
                    <br />
                    邮箱:
                    <a href="mailto:vip@entfly.com">vip@entfly.com</a>
                    <br />
                    售后: 400-808-9569
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="itembox">
                  <h2 class="title">山东聊城分公司</h2>
                  <p class="intro">
                    地址: 山东省聊城市聊城大学东校南门南临
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="qiao-contact">
<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=108706021&amp;site=qq&amp;menu=yes"></a>
</div>
  </div>
</template>
<script>
// 引入js
import Swiper from "swiper";
// 引入css
import "swiper/css/swiper.min.css";
export default {
  name: 'home',

  data() {
    return {
      leftMenu: true,
      leftMenuData: [
        {
          name: '首页',
          name1: 'home'
        }, {
          name: '服务',
          name1: 'Service'
        }, {
          name: '产品',
          name1: 'Product'
        }, {
          name: '客户',
          name1: 'Customer'
        }, {
          name: '介绍',
          name1: 'Intro'
        }, {
          name: '保障',
          name1: 'Security'
        }, {
          name: '动态',
          name1: 'News'
        }, {
          name: '联系',
          name1: 'Contact'
        }, {
          name: '助力官网',
          name1: 'Powersoft'
        }
      ],
      Swiper: null,
      HomeRight: null,
      HomeLeft: null,
      homeLeftIndex: 0,
      HomeNavData: 3,
      currentIndex:null,
      homeLeftIndexData: [{ class: "" }, { class: 'even' }, { class: "" }]
    }
  },
  watch: {
    homeLeftIndex(n, v) {
      console.log(n, v, 'ffff')
    }
  },
  created(){
    setTimeout(()=>{
      this.currentIndex = 0
    },0)
  },
  mounted() {
    this.getSwiper()
  },
  methods: {
    leftMenuClick() {
      this.leftMenu = !this.leftMenu;
    },
    SwiperIndexClick(index){
      this.Swiper.slideTo(index)
    },
    getSwiper() {
      let that = this;
      that.Swiper = new Swiper(".swiper", {
        direction: "vertical", // 垂直切换选项
        loop: false, // 循环模式选项
        mousewheel: true, // 是否开启鼠标滚轮控制swiper切换 ，默认false
        on: {
          slideChangeTransitionEnd: () => {
            that.currentIndex = that.$refs.swiper.swiper.activeIndex 
          },
        },
      });
      that.HomeRight = new Swiper(".home .home-right", {
        direction: "vertical", // 垂直切换选项
        loop: false, // 循环模式选项
        autoplay: false, // 开启自动循环
      });
      that.HomeLeft = new Swiper(".home .home-left", {
        direction: "vertical", // 垂直切换选项
        loop: false, // 循环模式选项
        autoplay: true, // 开启自动循环
        on: {
          slideChangeTransitionStart: () => {
            if (that.$refs.homeLeft) {
              that.homeLeftIndex = that.$refs.homeLeft.swiper.activeIndex;
              that.HomeRight.slideTo(that.$refs.homeLeft.swiper.activeIndex)

            }

          }
        }
      });
      new Swiper(".servitems", {
        loop: true,
        slidesPerView: 2,
        navigation: {
          nextEl: ".swiper-button-next", // 右按钮
          prevEl: ".swiper-button-prev", // 左按钮
        },
      });
      new Swiper(".caseitems", {
        slidesPerView: 3,
        paginationClickable: true,
      });
      // new Swiper(".response .swiper-container", {
      //     slidesPerView: 'auto',
      // });
    }
  }
};
</script>

<style>
li {
  list-style: none;
}

.container {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
}

.header .logo {
  position: absolute;
  top: 35px;
  left: 32px;
  width: 422px;
  height: 51px;
}

.header .logo img {
  position: absolute;
  top: 0;
  left: 0;
}

.header .logo .logo1 {
  position: relative;
  -webkit-transition: all 1s;
  transition: all 1s;
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
  opacity: 1;
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  z-index: 10;
}

.header .logo .logo2 {
  position: relative;
  -webkit-transition: all 1s;
  transition: all 1s;
  -webkit-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  opacity: 0;
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
  z-index: 9;
}

.header .logo.active .logo1 {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  opacity: 0;
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
  z-index: 9;
}

.header .logo.active .logo2 {
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
  opacity: 1;
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  z-index: 10;
}

.header .nav {
  position: fixed;
  top: 0;
  right: -280px;
  bottom: 0;
  width: 350px;
}

.header .nav.right {
  -webkit-transition: all .5s;
  transition: all .5s;
  right: 0;
}

.header .nav.rights {
  -webkit-transition: all .5s;
  transition: all .5s;
  right: -280px;
}

.header .nav .btn_control {
  position: absolute;
  left: 0px;
  top: 35px;
  width: 34px;
  height: 34px;
  -webkit-transition: all .5s;
  transition: all .5s;
  border-radius: 5px;
}

.header .nav .btn_control.close {
  -webkit-transform: rotate(360deg);
  -ms-transform: rotate(360deg);
  transform: rotate(360deg);
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/nav_close.png) no-repeat center center;
}

.header .nav .btn_control.open {
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/nav_open.png) no-repeat center center;
}

.header .nav .btn_control:hover {
  box-shadow: 0 0 5px #333;
}

.header .nav .list {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 280px;
  height: 100%;
}

.header .nav .list .mask {
  position: absolute;
  z-index: 998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: .9;
  background-color: #317cc0;
  filter: alpha(opacity=90);
}

.header .nav .list ul {
  position: relative;
  z-index: 999;
  margin-top: 20%;
}

.header .nav .list ul li {
  font-size: 18px;
  line-height: 66px;
  overflow: hidden;
  height: 66px;
  -webkit-transition: all 1.5s;
  transition: all 1.5s;
  text-align: center;
}

.header .nav .list ul li a {
  display: block;
  -webkit-transition: all .5s;
  transition: all .5s;
  text-decoration: none;
  color: #fff;
}

.header .nav .list ul li:hover,
.header .nav .list ul li.on {
  background: #5a96cd;
}

.header .nav .list ul li:hover a,
.header .nav .list ul li.on a {
  -webkit-transform: translateY(-66px);
  -ms-transform: translateY(-66px);
  transform: translateY(-66px);
}

.contents {
  height: 919px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.contents .home {
  position: relative;
}

.contents .section {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.contents .section .box {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  -webkit-transition: all 1s;
  transition: all 1s;
  -webkit-transform: skewX(-30deg) rotateX(-45deg);
  transform: skewX(-30deg) rotateX(-45deg);
  -webkit-transform-origin: left top;
  -ms-transform-origin: left top;
  transform-origin: left top;
  border: 1px solid #ddd;
}

.contents .section.active .box {
  -webkit-transform: rotateX(0deg);
  transform: rotateX(0deg);
}

.home .home-left {
  position: relative;
  overflow: hidden;
  width: 50%;
  height: 100%;
}

.home .swiper-wrapper {
  width: 100%;
  height: 100%;
}

.home .swiper-wrapper .swiper-slide {
  width: 100%;
  height: 100%;
}

.home .home-left .slidepannel {
  width: 100%;
  height: 100%;
}

.home .home-left .slidepannel.slidepannel-1 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/home-1.jpg) no-repeat center center;
  background-size: 100% auto;
}

.home .home-left .slidepannel.slidepannel-2 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/home-2.jpg) no-repeat center center;
  background-size: 100% auto;
}

.home .home-left .slidepannel.slidepannel-3 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/home-3.jpg) no-repeat center center;
  background-size: 100% auto;
}

.home .home-nav {
  position: absolute;
  z-index: 999;
  top: 35%;
  right: 50%;
  margin-right: 20px;
}

.home .home-nav i {
  display: block;
  width: 16px;
  height: 18px;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/homenav.png) no-repeat left bottom;
}

.home .home-right {
  overflow: hidden;
  width: 50%;
  height: 100%;
}

.home .home-right .slidepannel {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
}

.home .home-right .slidepannel.slidepannel-1 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/home-4.jpg) no-repeat center center;
  background-size: 100% auto;
}

.home .home-right .slidepannel.slidepannel-2 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/home-5.jpg) no-repeat center center;
  background-size: 100% auto;
}

.home .home-right .slidepannel.slidepannel-3 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/home-6.jpg) no-repeat center center;
  background-size: 100% auto;
}

.home .home-nav i.on {
  background-position: left -18px;
}

.home .home-nav i.even {
  background-position: left -36px;
}

.home .home-nav i.even.on {
  background-position: left 0px;
}

.home .home-left {
  position: relative;
  float: left;
  overflow: hidden;
  width: 50%;
  height: 100%;
}



.service .caption {
  padding-top: 70px;
}

.service .caption .en {
  width: 319px;
  height: 30px;
  margin: 0 auto;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/whatcanwedo.png) no-repeat 0 0;
}

.service .caption .ch {
  width: 142px;
  height: 23px;
  margin: 0 auto;
  margin-top: 22px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/whatcanwedo2.png) no-repeat 0 0;
}

.service .servitems {
  position: relative;
  overflow: hidden;
  width: 1100px;
  height: 200px;
  margin: 0 auto;
}

.service .servitems .item {
  padding: 30px 0;
}

.service .servitems .item .pic {
  display: block;
  height: 60px;
  margin-bottom: 10px;
}

.service .servitems .item .intro {
  line-height: 1.8em;
  display: block;
  text-align: center;
  color: #666;
}

.service .servitems .item .name {
  line-height: 1.8em;
  display: block;
  text-align: center;
  color: #317cc0;
}

.service .servitems .item.item1 .pic {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico1.png) no-repeat center bottom;
}

.service .servitems .item.item2 .pic {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico2.png) no-repeat center bottom;
}

.service .servitems .item.item3 .pic {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico3.png) no-repeat center bottom;
}

.service .servitems .item.item4 .pic {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico4.png) no-repeat center bottom;
}

.service .servitems .item.item5 .pic {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico5.png) no-repeat center bottom;
}

.service .servitems .prev,
.service .servitems .next {
  position: absolute;
  z-index: 999;
  top: 50%;
  zoom: 1;
  width: 28px;
  height: 50px;
  margin-top: -25px;
}

.service .servitems .prev {
  left: 0;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/prev.png) no-repeat center center;
}

.service .servitems .next {
  right: 0;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/next.png) no-repeat center center;
}

.service .advertising {
  position: relative;
  z-index: 9;
  width: 1080px;
  height: 370px;
  margin: 0 auto;
  margin-bottom: 40px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/servicead.png) no-repeat center top;
}

.service .tonext {
  font-size: 28px;
  line-height: 68px;
  display: block;
  width: 325px;
  height: 68px;
  margin: 0 auto;
  text-align: center;
  text-decoration: none;
  color: #317cc0;
  border: 1px solid #317cc0;
  border-radius: 30px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/servertonext.png) no-repeat center center;
}

.service .tonext:hover {
  background-color: #317cc0;
  background-image: url(http://kj.entfly.com/template/yibai_guanwang/public/images/servertonext1.png);
}

.service .san {
  position: absolute;
  top: 160px;
  left: 50%;
  width: 64px;
  height: 547px;
  margin-left: -32px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico6.png) no-repeat;
}

.cases .caption {
  margin-bottom: 68px;
  padding-top: 165px;
}

.cases .caption .en {
  width: 190px;
  height: 36px;
  margin: 0 auto;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/casetit.png) no-repeat 0 0;
}

.cases .caption .ch {
  width: 103px;
  height: 26px;
  margin: 0 auto;
  margin-top: 22px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/casetit2.png) no-repeat 0 0;
}

.cases .caseitems {
  width: 1000px;
  height: 340px;
  margin: 0 auto;
}

.cases .caseitems .item {
  width: 340px;
  margin-right: 20px;
  border-bottom: 1px solid #cfcfcf;
}

.cases .caseitems .item .pic {
  display: block;
  height: 200px;
}

.cases .caseitems .item .pic img {
  display: block;
  width: 100%;
  height: 100%;
}

.cases .caseitems .item .info {
  padding: 10px 20px;
}

.cases .caseitems .item .info .type {
  font-size: 12px;
  line-height: 28px;
  display: block;
  height: 28px;
  color: #b1b1b1;
}

.cases .caseitems .item .info .name {
  font-size: 16px;
  line-height: 28px;
  display: block;
  height: 28px;
  text-decoration: none;
  color: #666;
}

.cases .caseitems .item .info .intro {
  font-size: 12px;
  line-height: 28px;
  display: block;
  height: 28px;
  color: #b1b1b1;
}

.cases .caseitems .item:hover {
  border-bottom: 0;
  box-shadow: 0 0 16px #ddd;
}

.cases .scrollbar {
  position: relative;
  width: 1000px;
  margin: 0 auto;
  text-align: right;
  border: 0;
  border-top: 1px dotted #ccc;
}

.cases .scrollbar .pagenum {
  position: absolute;
  top: -12px;
}

.cases .scrollbar .pagenum:before,
.cases .scrollbar .pagenum:after {
  content: " ";
  display: table;
}

.cases .scrollbar .pagenum:after {
  clear: both;
}

.cases .scrollbar .pagenum .bullets {
  float: left;
  height: 23px;
  margin: 0;
  padding: 0;
  border-radius: 0;
}

.cases .scrollbar .btn_scroll {
  position: absolute;
  z-index: 2;
  top: -12px;
  left: 0;
  width: 100px;
  height: 23px;
  cursor: pointer;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/but.png) no-repeat;
}

.cases .scrollbar .more {
  display: inline-block;
  width: 56px;
  height: 16px;
  margin-top: 30px;
  -webkit-animation: doudong .4s infinite linear;
  animation: doudong .4s infinite linear;
  vertical-align: middle;
  text-decoration: none;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico7.png) no-repeat 0 0;
}

.customer {
  position: relative;
}

.customer .customerwrap {
  position: relative;
  overflow: hidden;
  width: 1700px;
  margin: 0 auto;
  margin-top: 120px;
  padding-bottom: 200px;
}

.customer .cooperation {
  position: absolute;
  z-index: 99;
  top: -100%;
  left: 0px;
  float: left;
  width: 375px;
  height: 572px;
  -webkit-transition: top .5s linear .3s;
  transition: top .5s linear .3s;
  opacity: .9;
  background: #4588c6;
}

.customer .cooperation .row1 {
  width: 229px;
  height: 27px;
  margin: 0 auto;
  margin-top: 63px;
  margin-bottom: 20px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/cp1.png) no-repeat 0 0;
}

.customer .cooperation .row2 {
  width: 216px;
  height: 24px;
  margin: 0 auto;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/cp2.png) no-repeat 0 0;
}

.customer .cooperation .row3 {
  font-family: Arial;
  font-size: 70px;
  line-height: 1.8em;
  text-align: center;
  color: #fff;
}

.customer .cooperation .row4 {
  width: 225px;
  height: 133px;
  margin: 0 auto;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/cp3.png) no-repeat 0 0;
}

.customer .cooperation .row5 {
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 187.5px solid transparent;
  border-bottom: 50px solid #fff;
  border-left: 187.5px solid transparent;
}

.customer .itemlist {
  position: relative;
  top: 0;
  right: -100%;
  float: right;
  overflow: hidden;
  width: 1152px;
  padding: 40px 100px;
  -webkit-transition: all 0.5s ease-out 0.8s;
  transition: all 0.5s ease-out 0.8s;
  opacity: 0;
  border: 1px solid #cfcfcf;
  filter: alpha(opacity=0);
}

.customer .itemlist ul {
  overflow: hidden;
  height: 440px;
}

.customer .itemlist ul:before,
.customer .itemlist ul:after {
  content: " ";
  display: table;
}

.customer .itemlist ul:after {
  clear: both;
}

.customer .itemlist ul li {
  float: left;
  overflow: hidden;
  width: 230px;
  height: 150px;
  margin-top: -1px;
  margin-left: -1px;
  -webkit-transition: all .5s;
  transition: all .5s;
  border-top: 1px dashed #cfcfcf;
  border-left: 1px dashed #cfcfcf;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/clients.png) no-repeat left top;
}

.customer .itemlist ul li:hover {
  background-color: #f2f2f2;
}

.customer .itemlist ul li.item1 {
  background-position: 0px 0px;
}

.customer .itemlist ul li.item1:hover {
  background-position: 0px -150px;
}

.customer .itemlist ul li.item2 {
  background-position: -230px 0px;
}

.customer .itemlist ul li.item2:hover {
  background-position: -230px -150px;
}

.customer .itemlist ul li.item3 {
  background-position: -460px 0px;
}

.customer .itemlist ul li.item3:hover {
  background-position: -460px -150px;
}

.customer .itemlist ul li.item4 {
  background-position: -690px 0px;
}

.customer .itemlist ul li.item4:hover {
  background-position: -690px -150px;
}

.customer .itemlist ul li.item5 {
  background-position: -920px 0px;
}

.customer .itemlist ul li.item5:hover {
  background-position: -920px -150px;
}

.customer .itemlist ul li.item6 {
  background-position: -1150px 0px;
}

.customer .itemlist ul li.item6:hover {
  background-position: -1150px -150px;
}

.customer .itemlist ul li.item7 {
  background-position: -1380px 0px;
}

.customer .itemlist ul li.item7:hover {
  background-position: -1380px -150px;
}

.customer .itemlist ul li.item8 {
  background-position: -1610px 0px;
}

.customer .itemlist ul li.item8:hover {
  background-position: -1610px -150px;
}

.customer .itemlist ul li.item9 {
  background-position: -1840px 0px;
}

.customer .itemlist ul li.item9:hover {
  background-position: -1840px -150px;
}

.customer .itemlist ul li.item10 {
  background-position: -2070px 0px;
}

.customer .itemlist ul li.item10:hover {
  background-position: -2070px -150px;
}

.customer .itemlist ul li.item11 {
  background-position: -2300px 0px;
}

.customer .itemlist ul li.item11:hover {
  background-position: -2300px -150px;
}

.customer .itemlist ul li.item12 {
  background-position: -2530px 0px;
}

.customer .itemlist ul li.item12:hover {
  background-position: -2530px -150px;
}

.customer .itemlist ul li.item13 {
  background-position: -2760px 0px;
}

.customer .itemlist ul li.item13:hover {
  background-position: -2760px -150px;
}

.customer .itemlist ul li.item14 {
  background-position: -2990px 0px;
}

.customer .itemlist ul li.item14:hover {
  background-position: -2990px -150px;
}

.customer .itemlist ul li.item15 {
  background-position: -3220px 0px;
}

.customer .itemlist ul li.item15:hover {
  background-position: -3220px -150px;
}

.customer.active .cooperation {
  top: 40px;
}

.customer.active .itemlist {
  right: 0;
  opacity: 1;
  filter: alpha(opacity=100);
}

@-webkit-keyframes doudong {
  0% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }

  25% {
    -webkit-transform: rotateZ(-10deg);
    transform: rotateZ(-10deg);
  }

  50% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }

  75% {
    -webkit-transform: rotateZ(-10deg);
    transform: rotateZ(-10deg);
  }

  100% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }
}

@keyframes doudong {
  0% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }

  25% {
    -webkit-transform: rotateZ(-10deg);
    transform: rotateZ(-10deg);
  }

  50% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }

  75% {
    -webkit-transform: rotateZ(-10deg);
    transform: rotateZ(-10deg);
  }

  100% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }
}

@-webkit-keyframes bianzhuan {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes bianzhuan {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.response {
  position: relative;
}

.response .caption {
  position: absolute;
  z-index: 999;
  top: 190px;
  right: 125px;
  width: 480px;
  height: 480px;
}

.response .caption .bian {
  display: block;
  width: 100%;
  height: 100%;
  border: 1px dashed #ccc;
  border-radius: 50%;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/rs1.png) no-repeat center center #ffffff;
}

.response .itemwrap {
  position: absolute;
  top: 238px;
  right: 510px;
  left: 35px;
  height: 385px;
  border-top: 1px dashed #ccc;
  border-bottom: 1px dashed #ccc;
}

.response .itemwrap .next {
  position: absolute;
  top: 50%;
  right: 150px;
  width: 35px;
  height: 35px;
  -webkit-transition: all .5s;
  transition: all .5s;
  border: 1px solid #999;
  border-radius: 50%;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/next1.png) no-repeat center center;
}

.response .itemwrap .next:hover {
  border-color: #fff;
  box-shadow: 0 0 5px #333;
}

.response .itemwrap .swiper-container {
  position: absolute;
  /*  right: 240px;*/
  right: 210px;
  bottom: 0;
  width: 960px;
  height: 460px;
}

.response .itemwrap .swiper-container ul li {
  position: relative;
  bottom: -150px;
  overflow: hidden;
  width: 320px;
  height: 460px;
  -webkit-transition: all .5s;
  transition: all .5s;
}

.response .itemwrap .swiper-container ul li .item {
  overflow: hidden;
  padding: 0 10px;
}

.response .itemwrap .swiper-container ul li .pic img {
  display: block;
  width: 320px;
  height: 220px;
  -webkit-transition: all .5s;
  transition: all .5s;
  opacity: .5;
  filter: alpha(opacity=50);
}

.response .itemwrap .swiper-container ul li .intro dt {
  font-size: 16px;
  line-height: 50px;
  height: 50px;
  -webkit-transition: all 1s;
  transition: all 1s;
  text-align: center;
  margin-bottom: 50px;
}

.response .itemwrap .swiper-container ul li .intro dd {
  line-height: 25px;
  overflow: hidden;
  height: 50px;
  text-align: center;
  color: #b5b5b5;
}

.response .itemwrap .swiper-container ul li:hover {
  bottom: -85px;
}

.response .itemwrap .swiper-container ul li:hover dt {
  margin-bottom: 0px;
}

.response .itemwrap .swiper-container ul li:hover .pic img {
  opacity: 1;
  filter: alpha(opacity=100);
}

.response .itemwrap .swiper-container ul li:hover .intro dt {
  margin-bottom: 0;
}

.news .n-side {
  position: relative;
  float: left;
  width: 50%;
  height: 100%;
  background: #317bc0;
}

.news .n-side .caption {
  position: absolute;
  top: 27%;
  left: 50%;
  width: 513px;
  height: 56px;
  margin-left: -256px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/newstit.png) no-repeat 0 0;
}

.news .n-side .newslist {
  position: absolute;
  top: 39%;
  left: 45%;
  width: 430px;
  height: 350px;
  margin-left: -192px;
  color: #fff;
}

.news .n-side .newslist .hd {
  margin-bottom: 20px;
}

.news .n-side .newslist .bd {
  height: 250px;
}

.news .n-side .newslist .bd ul li {
  line-height: 40px;
  overflow: hidden;
  height: 40px;
}

.news .n-side .newslist .bd ul li:hover {
  cursor: pointer;
  color: #a9d6ff;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico8.png) no-repeat 314px 15px;
}

.news .n-side .newslist .ft {
  position: relative;
  right: -100px;
  text-align: right;
}

.news .n-side .newslist .ft a {
  font-family: 'å®‹ä½“';
  font-size: 18px;
  font-weight: bold;
  line-height: 40px;
  display: inline-block;
  width: 45px;
  height: 40px;
  text-align: center;
  text-decoration: none;
  color: #317bc0;
  background: #fff;
}

.news .n-main {
  float: right;
  width: 50%;
  height: 100%;
  background: #fff;
  position: relative;
}

.news .n-main .newsdetail {
  position: absolute;
  top: 10%;
  bottom: 10%;
  left: 15%;
  right: 15%;
  overflow: hidden;
}

.news .n-main .newsdetail .hd {
  border-bottom: 1px solid #cfcfcf;
}

.news .n-main .newsdetail .hd .title {
  font-size: 24px;
  line-height: 30px;
  overflow: hidden;
  height: 30px;
  color: #222;
}

.news .n-main .newsdetail .hd .title-bar {
  line-height: 50px;
  overflow: hidden;
  height: 50px;
  color: #cfcfcf;
}

.news .n-main .newsdetail .bd {
  position: absolute;
  top: 100px;
  bottom: 0px;
  left: 0px;
  right: -20px;
  overflow-x: hidden;
  overflow-y: auto;
}

.news .n-main .newsdetail .bd .content {
  font-size: 16px;
  line-height: 30px;
  overflow: hidden;
}

.news .n-main .newsdetail .bd .content p {
  margin-bottom: 30px;
}

.contact .banner {
  overflow: hidden;
  height: 50%;
}

.contact .banner .banner1 {
  height: 100%;
  -webkit-transition: all 40s;
  transition: all 40s;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/contactbanner.jpg) no-repeat center center;
  background-size: 100% auto;
}

.contact .itemlist {
  height: 50%;
}

.contact .itemlist:before,
.contact .itemlist:after {
  content: " ";
  display: table;
}

.contact .itemlist:after {
  clear: both;
}

.contact .itemlist .item {
  float: left;
  width: 50%;
  padding-top: 80px;
}

.contact .itemlist .item .itembox {
  padding-left: 15%;
}

.contact .itemlist .item .title {
  font-size: 18px;
  line-height: 2em;
  display: block;
  height: 2em;
}

.contact .itemlist .item .intro {
  line-height: 2em;
  display: block;
}

.contact .itemlist .item .intro a {
  text-decoration: none;
  color: #317bc0;
}

.contact.active .banner .banner1 {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}

.security .caption {
  margin-top: 10%;
}

.security .caption .en {
  width: 274px;
  height: 27px;
  margin: 0 auto;
  margin-bottom: 20px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/st1.png) no-repeat center center;
}

.security .caption .ch {
  width: 96px;
  height: 24px;
  margin: 0 auto;
  margin-bottom: 20px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/st2.png) no-repeat center center;
}

.security .itemlist {
  width: 1330px;
  margin: 0 auto;
  padding-top: 86px;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/sline1.png) no-repeat center top;
}

.security .itemlist ul {
  padding-top: 20px;
}

.security .itemlist ul:before,
.security .itemlist ul:after {
  content: " ";
  display: table;
}

.security .itemlist ul:after {
  clear: both;
}

.security .itemlist ul li {
  float: left;
  width: 16.5%;
}

.security .itemlist .item {
  overflow: hidden;
  padding: 0 10px;
  text-align: center;
}

.security .itemlist .item i {
  display: block;
  width: 46px;
  height: 46px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.security .itemlist .item h2 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #222;
}

.security .itemlist .item p {
  line-height: 2em;
  color: #999;
}

.security .itemlist .item.item1 i {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/sico1.png) no-repeat center center;
}

.security .itemlist .item.item2 i {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/sico2.png) no-repeat center center;
}

.security .itemlist .item.item3 i {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/sico3.png) no-repeat center center;
}

.security .itemlist .item.item4 i {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/sico4.png) no-repeat center center;
}

.security .itemlist .item.item5 i {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/sico5.png) no-repeat center center;
}

.security .itemlist .item.item6 i {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/sico6.png) no-repeat center center;
}

.about .itemlist {
  width: 1115px;
  margin: 0 auto;
  margin-top: 95px;
}

.about .itemlist ul {
  overflow: hidden;
}

.about .itemlist ul:before,
.about .itemlist ul:after {
  content: " ";
  display: table;
}

.about .itemlist ul:after {
  clear: both;
}

.about .itemlist ul li {
  position: relative;
  float: left;
  height: 290px;
  margin-top: -1px;
  margin-left: -1px;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
}

.about .itemlist ul li.letter {
  width: 222px;
}

.about .itemlist ul li.letter .title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: all .5s;
  transition: all .5s;
  opacity: 1;
  background: #fff;
}

.about .itemlist ul li.letter .title2 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: all .5s;
  transition: all .5s;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  opacity: 0;
  filter: alpha(opacity=0);
}

.about .itemlist ul li.letter .info {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 20px;
  -webkit-transition: all .5s;
  transition: all .5s;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  text-align: center;
  opacity: 0;
  background: #317bc0;
  filter: alpha(opacity=0);
}

.about .itemlist ul li.letter .info h2 {
  font-size: 18px;
  line-height: 2em;
  color: #fff;
}

.about .itemlist ul li.letter .info p {
  line-height: 2em;
  color: #fff;
}

.about .itemlist ul li.letter:hover .title {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  opacity: 0;
  filter: alpha(opacity=0);
}

.about .itemlist ul li.letter:hover .title2 {
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
  opacity: 1;
  filter: alpha(opacity=100);
}

.about .itemlist ul li.letter:hover .info {
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
  opacity: 1;
  filter: alpha(opacity=100);
}

.about .itemlist ul li.letter.letter-a .title {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/a.png) no-repeat center center;
}

.about .itemlist ul li.letter.letter-b .title {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/b.png) no-repeat center center;
}

.about .itemlist ul li.letter.letter-o .title {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/o.png) no-repeat center center;
}

.about .itemlist ul li.letter.letter-u .title {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/u2.png) no-repeat center center;
}

.about .itemlist ul li.letter.letter-u .title2 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/u.png) no-repeat center center #317bc0;
}

.about .itemlist ul li.letter.letter-t .title {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/t.png) no-repeat center center;
}

.about .itemlist ul li.letter.letter-s .title {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/s2.png) no-repeat center center;
}

.about .itemlist ul li.letter.letter-s .title2 {
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/s1.png) no-repeat center center #317bc0;
}

.about .itemlist ul li.intro {
  width: 666px;
}

.about .itemlist ul li.intro .title {
  font-size: 26px;
  padding: 15px;
  color: #bcbcbc;
}

.about .itemlist ul li.intro .content {
  line-height: 2em;
  margin: 0 20px 20px 20px;
  color: #222;
}

.about .itemlist ul li.intro .pic {
  display: none;
  text-align: center;
}

@media screen and (max-width: 1860px) {
  .customer .customerwrap {
    width: 1450px;
  }

  .customer .itemlist {
    width: 920px;
  }
}

@media screen and (max-width: 1630px) {
  .customer .customerwrap {
    width: 1230px;
  }

  .customer .itemlist {
    width: 690px;
  }

  .response .itemwrap .swiper-container {
    width: 640px;
  }
}

@media screen and (max-width: 1366px) {
  .customer .customerwrap {
    width: 1000px;
  }

  .customer .itemlist {
    width: 460px;
  }

  .header .nav {
    width: 280px;
  }

  .header .nav .list {
    width: 210px;
  }

  .header .nav .list ul li a {
    font-size: 16px;
  }
}

@media screen and (max-width: 1024px) {
  .service .servitems {
    width: 860px;
  }

  .customer .itemlist {
    width: 460px;
  }

  .about .itemlist {
    width: 900px;
  }

  .about .itemlist ul li.letter {
    width: 180px;
  }

  .about .itemlist ul li.intro {
    width: 540px;
  }

  .response .caption {
    display: none;
  }

  .response .itemwrap {
    width: 90%;
    border: 0;
  }

  .response .itemwrap .next {
    display: none;
  }

  .response .itemwrap .swiper-container {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    height: auto;
  }
}

@media screen and (max-width: 860px) {
  .service .servitems {
    width: 760px;
  }

  .cases .caseitems {
    width: 100%;
  }

  .about .itemlist {
    width: 100%;
  }

  .about .itemlist ul li.letter {
    display: none;
  }

  .about .itemlist ul li.intro {
    width: auto;
  }

  .about .itemlist ul li.intro p {
    margin-bottom: 1em;
  }
}

@media screen and (max-width: 760px) {
  .welcome .loadpic {
    width: 60%;
  }

  .welcome .loadpic .title {
    height: 60px;
  }

  .welcome .loadpic .progress .preogress-shadow {
    height: 4em;
  }

  .header {
    height: 60px;
    background-color: #fff;
    box-shadow: 0 1px 5px #ddd;
  }

  .header .logo {
    top: 0;
    left: 0;
    overflow: hidden;
    width: 120px;
    height: 100%;
  }

  .header .logo img {
    top: 12px;
    left: 12px;
    width: 280px;
  }

  .header .nav .btn_control {
    position: fixed;
    top: 12px;
    right: 10px;
    margin: 0;
    padding: 0;
  }

  .footer {
    display: none;
  }

  .container {
    top: 60px;
    bottom: 0;
  }

  .home .home-nav {
    display: none;
  }

  .home .home-left {
    display: none;
  }

  .home .home-right {
    width: 100%;
  }

  .home .home-right .slidepannel {
    background-size: auto 100%;
  }

  .service .servitems {
    width: 100%;
    background: none;
  }

  .service .servitems .prev,
  .service .servitems .next {
    padding: 10px;
  }

  .service .servitems .item {
    padding: 30px 50px;
  }

  .service .advertising {
    display: none;
  }

  .service .san {
    display: none;
  }

  .service .tonext {
    width: 80%;
    background-size: 80% auto;
  }

  .cases .caption {
    margin-bottom: 0;
    padding: 6% 0;
  }

  .cases .caseitems {
    overflow: hidden;
    width: auto;
    margin: 0 20px;
  }

  .cases .caseitems .item {
    margin: 0 auto;
  }

  .cases .scrollbar {
    display: none;
  }

  .customer .cooperation {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
  }

  .customer .cooperation .row5 {
    display: none;
  }

  .customer.active .cooperation {
    z-index: 888;
    top: 0;
    -webkit-transition: all 0.5s ease-out 2s;
    transition: all 0.5s ease-out 2s;
    opacity: 0;
  }

  .customer.active .itemlist {
    z-index: 999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0;
    -webkit-transition: all 0.5s ease-out 2s;
    transition: all 0.5s ease-out 2s;
    border: 0;
  }

  .customer.active .itemlist ul {
    width: auto;
    height: auto;
  }

  .customer.active .itemlist ul li {
    float: left;
    width: 38%;
    height: auto;
    margin-top: 8%;
    margin-left: 8%;
    border: 0;
    background-color: #fff;
  }

  .customer.active .itemlist ul li img {
    width: 100%;
  }

  .news .n-side {
    width: 100%;
  }

  .news .n-side .caption {
    position: relative;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 90%;
    margin: 0 auto;
    margin-top: 15%;
    background-size: 100%;
  }

  .news .n-side .newslist {
    position: relative;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 90%;
    margin: 0 auto;
  }

  .news .n-main {
    display: none;
  }

  .contact .banner {
    display: none;
    height: 35%;
  }

  .contact .itemlist {
    height: auto;
    padding-top: 10px;
  }

  .contact .itemlist .item {
    float: none;
    width: auto;
    padding: 10px;
  }

  .contact .itemlist .item .itembox {
    padding: 0;
  }

  .contact .itemlist .item .intro {
    font-size: 13px;
    line-height: 1.8em;
  }

  .security .itemlist {
    width: 100%;
    padding-top: 20px;
    background: none;
  }

  .security .itemlist ul li {
    float: none;
    width: 100%;
  }

  .security .itemlist ul li .item.item1 i,
  .security .itemlist ul li .item.item2 i,
  .security .itemlist ul li .item.item3 i,
  .security .itemlist ul li .item.item4 i,
  .security .itemlist ul li .item.item5 i,
  .security .itemlist ul li .item.item6 i {
    float: left;
    width: 20px;
    height: 20px;
    margin-left: 20px;
    background-size: 100% 100%;
  }
}

@media screen and (max-height: 920px) {
  .service .caption {
    padding-top: 100px;
  }

  .service .tonext {
    display: none;
  }

  .service .san {
    top: 200px;
  }

  .security .caption {
    margin-top: 14%;
  }
}

@media screen and (max-height: 820px) {
  .service .caption {
    margin-bottom: 20px;
    padding-top: 200px;
  }

  .service .advertising {
    display: none;
  }

  .service .servitems {
    margin-bottom: 20px;
  }

  .service .tonext {
    display: block;
  }

  .service .san {
    top: 320px;
    height: 140px;
  }

  .customer .cooperation {
    display: none;
  }

  .customer .itemlist {
    float: none;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    border: 0;
    padding: 0px;
    margin: 0 auto;
  }

  .customer .itemlist ul {
    height: 449px;
  }

  .about .itemlist {
    margin-top: 100px;
  }
}

@media screen and (max-height: 760px) {
  .service .caption {
    margin-top: 12%;
    padding: 0;
  }

  .service .san {
    display: none;
  }

  .service .servitems {
    background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/ico6.png) no-repeat center top;
  }

  .cases .caption {
    padding-top: 100px;
  }

  .cases .caseitems {
    height: 220px;
  }

  .cases .scrollbar {
    text-align: center;
  }

  .cases .caseitems .item .info {
    display: none;
  }

  .about .itemlist ul li.letter {
    display: none;
  }

  .about .itemlist ul li.intro {
    height: auto;
    width: auto;
  }

  .about .itemlist ul li.intro p {
    margin-bottom: 1em;
  }

  .about .itemlist ul li.intro .pic {
    display: block;
  }

  .security .caption {
    margin-top: 10%;
  }

  .response .caption {
    top: 10%;
    right: 100px;
  }

  .response .itemwrap {
    top: 17%;
    right: 480px;
  }
}

@media screen and (max-height: 660px) {
  .service .tonext {
    display: none;
  }

  .security .itemlist .item p {
    display: block;
  }

  .header .nav .list ul li {
    line-height: 52px;
    height: 52px;
  }

  .header .nav .list ul li:hover,
  .header .nav .list ul li.on {
    background: #5a96cd;
  }

  .header .nav .list ul li:hover a,
  .header .nav .list ul li.on a {
    -webkit-transform: translateY(-52px);
    -ms-transform: translateY(-52px);
    transform: translateY(-52px);
  }

  .customer .itemlist ul {
    height: 299px;
  }
}

@media screen and (max-height: 660px) and (max-width: 1856px) {
  .customer .itemlist {
    width: 1152px;
  }
}

@media screen and (max-height: 660px) and (max-width: 1366px) {
  .customer .itemlist {
    width: 920px;
  }
}

.qiao-contact {
  position: fixed;
  z-index: 9999;
  left: 0px;
  bottom: 0px;
  width: 179px;
  height: 171px;
}

.qiao-contact a {
  display: block;
  width: 100%;
  height: 100%;
  background: url(http://kj.entfly.com/template/yibai_guanwang/public/images/contact.png) no-repeat 0px 0px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}

.qiao-contact.effect a {
  -webkit-transform: rotateY(360deg);
  transform: rotateY(360deg);
  background-position: 0px -171px;
}

.news .n-side .newslist .bd ul li a {
  color: #fff;
}
</style>
